'use client'

import { createContext, type ReactNode, useContext, useState } from 'react'

type PageTitleState = {
  titleContent: ReactNode
  rightContent: ReactNode
}

type PageTitleContextValue = {
  state: PageTitleState
  setState: (next: PageTitleState) => void
}

const PageTitleContext = createContext<PageTitleContextValue | null>(null)

export function PageTitleProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<PageTitleState>({
    titleContent: null,
    rightContent: null,
  })

  return (
    <PageTitleContext.Provider value={{ state, setState }}>
      {children}
    </PageTitleContext.Provider>
  )
}

export function usePageTitle(): PageTitleState {
  const ctx = useContext(PageTitleContext)
  if (!ctx) {
    throw new Error('usePageTitle must be used within a PageTitleProvider')
  }
  return ctx.state
}

export function useSetPageTitle(): (next: PageTitleState) => void {
  const ctx = useContext(PageTitleContext)
  if (!ctx) {
    throw new Error('useSetPageTitle must be used within a PageTitleProvider')
  }
  return ctx.setState
}
